import React from 'react';
import { useMount, useUnmount } from 'ahooks';

export default function useCloseWhenClickOutSide(props: {
  dropDown: React.MutableRefObject<HTMLDivElement | null>;
  popover: React.MutableRefObject<HTMLDivElement | null>;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsError: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { dropDown, popover, setIsOpen, setIsError } = props;

  // 点击目标元素外面判断是否关闭弹层
  const handleOutSideClick = (e: Event) => {
    // 判断点击元素是否在Dropdown组件内
    if (dropDown?.current?.contains(e.target as HTMLElement)) return;

    // 判断点击元素是否在弹层内
    if (popover?.current?.contains(e.target as HTMLElement)) return;

    // 判断点击元素是否再select弹层内
    const popoverDom = document.getElementsByClassName('dbi—revenue—growth-select-popover');
    if (!!popoverDom.length) return;

    setIsOpen(false);
    setIsError(false);
  };

  useMount(() => {
    document.addEventListener('click', handleOutSideClick, true);
  });

  useUnmount(() => {
    document.removeEventListener('click', handleOutSideClick, true);
  });
}
